<template>
  <f7-page id="page-sendmoney-payment-summary" name="sendmoney--payment-summary" @page:afterin="afterin">
    <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link v-show="isMakePayment" icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>

    <f7-block>
      <div class="wandr-level-4">{{$t('sendmoney-payment-detail-page-title')}}</div>
      <!-- ALERT MESSAGE -->
      <f7-card
        id     = "errorCard"
        class  = "alert"
        v-show = "alertCard.show"
        :class = "alertCard.alertClass"
        >
          <div v-html="alertCard.title" slot="header"></div>
          <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
      </f7-card>

      <!-- BANK TRANSFER -->
      <div v-if="paymentMethodId == 2">
        <div class="mt-20 wandr-paragraph-4 text-color-gray">{{$t('sendmoney-text-make-payment-before')}}</div>
        <div class="mb-20 wandr-paragraph-4 b">{{payBeforeDate}}</div>

        <div class="card card-20 payment-summary">
          <div class="mb-20 wandr-level-3">{{$t('sendmoney-text-transfer-to')}}</div>

          <div class="payment-details mb-3">
            <div class="text-color-gray">{{$t('sendmoney-text-company-name')}}</div>
            <div class="mb-sm fw-medium">WANDR PTE LTD</div>

            <div class="text-color-gray">{{ $t('sendmoney-text-bank') }}</div>
            <div class="mb-sm fw-medium">
              <div>JPMorgan Chase Bank, N.A. (Bank #7153)</div>
              <div>
                <img :src="getBankImg(267)" style="width:60px">
              </div>
            </div>

            <div class="text-color-gray">{{$t('sendmoney-text-branch')}}</div>
            <div class="mb-sm fw-medium">001</div>

            <div class="text-color-gray">{{$t('sendmoney-text-acc-type')}}</div>
            <div class="mb-sm fw-medium">Current account</div>

            <div class="text-color-gray">{{$t('sendmoney-text-account-number')}}</div>
            <div class="mb-sm fw-medium">
              <div><span ref="accountnumber" id="accountnumber" >8830063362</span></div>
              <div class="pointer">
                <img :src="require('@/assets/img/icon/icon-copy.svg')" class="mr-sm" @click="copyText('accountnumber')">
              </div>
            </div>

            <div class="text-color-gray">{{$t('sendmoney-text-reference-no')}}</div>
            <div class="mb-sm fw-medium">
              <div><span ref="accountnumber" id="referenceno">S{{settlementId}}</span></div>
              <div class="pointer">
                <img :src="require('@/assets/img/icon/icon-copy.svg')" class="mr-sm" @click="copyText('referenceno')">
              </div>
            </div>
          </div>

          <div class="payment-total">
            <div class="wandr-level-3">{{$t('sendmoney-text-you-pay')}}</div>
            <div class="wandr-level-4">
              <span ref="totalAmountSettlement" id="totalAmountSettlement" >{{this.formatCurrency(totalAmountSettlement, 2) || 0}}</span> {{hostCurrency}}
              <img :src="require('@/assets/img/icon/icon-copy.svg')" class="mr-sm pointer" @click="copyText('totalAmountSettlement')"/>
            </div>
          </div>
        </div>

        <f7-button large fill class="mt-xl" @click="handleContinue()">
          {{$t('sendmoney-continue')}}
        </f7-button>

        <f7-button v-show="isMakePayment" large fill class="mb-sm color-gray6 text-color-green w-100 mt-xl" @click="handleChangePaymentMethod()">
          {{$t('sendmoney-change-payment-method')}}
        </f7-button>

      </div>
      <!-- PAYNOW -->
      <div v-else>
        <ul class="make-payment-guide-step">
          <li>{{$t('sendmoney-text-make-payment-before')}} <span>{{payBeforeDate}}</span></li>
          <li>{{$t('sendmoney-payment-detail-paynow-text-1')}}</li>
        </ul>

        <div id="qrCodeSection" class="card card-20">
          <div class="text-align-center"><img class="imgQR" :src="paynowQRCode"/></div>
          <div class="text-align-center">
            <div>UEN : 200720719MJPM</div>
            <div>{{$t('sendmoney-payment-detail-paynow-text-ref-no')}} S{{settlementId}}</div>
          </div>
        </div>

        <p class="mb-lg text-align-center wandr-paragraph-4">
          {{ $t('sendmoney-payment-detail-paynow-text-2') }}
        </p>

        <f7-button large fill :disabled="paynowQRCode.length > 22 ? false:true" @click="saveQRAsPhoto()">
          {{$t('sendmoney-text-btn-save-qr-to-photo')}}
        </f7-button>

        <f7-button large fill class="mb-sm color-gray6 text-color-green w-100 mt-xl" @click="handleContinue()">
          {{$t('sendmoney-continue')}}
        </f7-button>

        <f7-button v-show="isMakePayment" large fill class="mb-sm color-gray6 text-color-green w-100 mt-xl" @click="handleChangePaymentMethod()">
          {{$t('sendmoney-change-payment-method')}}
        </f7-button>

      </div>

    </f7-block>

  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    computed: {
			...mapGetters('auth', [
				'authenticating',
				'authenticationError',
				'authenticationErrorCode',
				'authenticationSuccess'
			])
		},

    data() {
			return {
        alertCard: {
          show             : false,
          title            : "",
          content          : "",
          alertClass       : "alert-danger"
        },
        hostCurrency       : "",
        isMakePayment      : false,
        payBeforeDate      : "",
        paymentMethodId    : "",
        paynowQRCode       : "",
        settlementId       : 0,
        totalAmountSettlement : 0,
			}
		},

    mounted(){
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })
      this.hostCurrency          = this.$store.state.transaction.hostCurrency
      this.payBeforeDate         = this.getMakeYourPaymentDate()
      this.paymentMethodId       = this.$store.state.transaction.paymentMethodId
      this.settlementId          = this.$store.state.transaction.settlementId
      this.totalAmountSettlement = this.$store.state.transaction.totalAmountSettlement
      this.isMakePayment         = this.$store.state.transaction.isMakePayment

      if(this.paymentMethodId == 14){
        this.generatePayNowQrCode()
      }
		},

    methods: {
      ...mapActions('auth', ['login']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      copyText(text){
        var copyText   = document.getElementById(text);
        var textArea   = document.createElement("textarea");
        textArea.value = (copyText.textContent).replace(/ /g,"");
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("Copy");
        textArea.remove();

        this.$f7.toast.create({
          text: 'Copied',
          position: 'center',
          closeTimeout: 1000,
        }).open()

      },

      formatCurrency(num, dec) {
        let val = (Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100).toFixed(dec)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },

      handleChangePaymentMethod(){
        this.$f7router.navigate("/sendmoney/enter-amount")
      },

      handleContinue(){
        if(this.isMakePayment){
          this.$f7router.navigate("/transaction-history-details", { transition: 'f7-push' });
        }else{
          this.$f7router.navigate("/sendmoney/payment-summary")
        }
      },

      generatePayNowQrCode(){
        const self             = this
        self.showPreloader()
        let generateQRCodeResp = ""

        generateQRCodeResp = this.$api.settlement.generatePayNowQRCode( self.settlementId, self.totalAmountSettlement );
        generateQRCodeResp.then(function(reponse) {
          if (reponse.status == '14000') {
            self.paynowQRCode = "data:image/png;base64,"+reponse.result.qrCode
          } else { // Generic error
            self.showErrorCard( self.$t('sendmoney-error-general', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
          }
          self.hidePreloader()
        })
      },

      saveQRAsPhoto(){
        this.showPreloader()
        if(window.Android) {
          window.Android.getWandrCallback(JSON.stringify({ "type": 'save_qr_image', 'data': this.paynowQRCode.substring(22) }));
        } else if(window.webkit) {
          window.webkit.messageHandlers.WandrCallbackHandler.postMessage(JSON.stringify({ "type": 'save_qr_image', 'data': this.paynowQRCode.substring(22) }));
        } else {
          const dwnElement = document.createElement('a');
          dwnElement.download = "Wandr-E_" + this.settlementId+"_qrcode.png";
          dwnElement.href = this.paynowQRCode;
          document.body.append()
          dwnElement.click()     //click to download qrcode
          dwnElement.remove()    //remove created element after download
        }
        this.hidePreloader()

        if(this.$f7.device.desktop){
          this.$f7.toast.create({
            text: 'Photo saved',
            position: 'center',
            closeTimeout: 1000,
          }).open()
        }
      },

      showErrorCard(errorMessage) {
        this.alertCard.title      = errorMessage
        this.alertCard.alertClass = 'alert-danger'
        this.alertCard.show       = true
      },
      backButton(){
        // this.$f7router.back("/transaction-history",{force:true})
        this.$f7router.back({ transition: 'f7-push' })
      },
    }

  }
</script>